/**
 * Events left sidebar. Reuses M List sidebar layout and filter group components
 * so the Events page uses the same filter UX as the M List listings page.
 */
import React from "react";
import { Link } from "react-router-dom";
import MListSidebarFilterGroup from "../mlist/MListSidebarFilterGroup";
import {
  ATTENDANCE_OPTIONS,
  CURATED_SERIES_OPTIONS,
  LOCATION_OPTIONS,
} from "./eventsFilterConfig";

export default function EventsSidebar({
  attendanceIds,
  onAttendanceIdsChange,
  curatedSeriesIds,
  onCuratedSeriesIdsChange,
  locationIds,
  onLocationIdsChange,
  onClearAll,
  hasActiveFilters,
}) {
  return (
    <aside className="twentytwentysix-content__mlist-sidebar" aria-label="Filter events">
      {hasActiveFilters && (
        <button
          type="button"
          className="twentytwentysix-content__filter-pill twentytwentysix-content__mlist-sidebar-clear"
          onClick={onClearAll}
        >
          Clear all filters
        </button>
      )}

      <MListSidebarFilterGroup
        title="Attendance Type"
        options={ATTENDANCE_OPTIONS}
        selectedIds={attendanceIds}
        onChange={onAttendanceIdsChange}
        ariaLabel="Attendance type filters"
      />

      <MListSidebarFilterGroup
        title="Curated Series"
        options={CURATED_SERIES_OPTIONS}
        selectedIds={curatedSeriesIds}
        onChange={onCuratedSeriesIdsChange}
        ariaLabel="Curated series filters"
      />

      <MListSidebarFilterGroup
        title="Location"
        options={LOCATION_OPTIONS}
        selectedIds={locationIds}
        onChange={onLocationIdsChange}
        ariaLabel="Location filters"
      />

      <div className="twentytwentysix-content__mlist-sidebar-cta">
        <p className="twentytwentysix-content__copy">Have an event to share?</p>
        <Link to="/twentytwentysix/contact" className="twentytwentysix-content__pill twentytwentysix-content__pill--outline">
          Contact us
        </Link>
      </div>
    </aside>
  );
}
